import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
  [ModulesConfigMap[ModulesMap.DONE_WORKS_DONE_FIELD_WORKS].GET_DONE_FIELD_WORKS]:{
    url:'/company/:companyId/done_works/done_field_works/'
  }
}